module.exports = __webpack_public_path__ + "img/refresh.30f94259.svg";